import { PATHS } from '../constants/routes';
import { Product } from '../types/common';

export type FirebaseObj = {
    [key: string]: {
        [key: string]: string | number | { [key: string]: string | number };
    };
};

export const handleObj = (obj: FirebaseObj | null): any[] => {
    if (!obj) {
        return [];
    }
    return Object.entries(obj).map(([id, fields]) => ({ id, ...fields }));
};

export const wait = async (ms: number) => {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
};

export async function getCsrfToken() {
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/csrf-token`, {
        credentials: 'include',
    });
    const data = await response.json();
    return data.csrfToken;
}

export function formatPrice(price: number | string) {
    const numericPrice = typeof price === 'number' ? price : Number(price);
    if (isNaN(numericPrice)) {
        throw new Error('Неверное значение цены');
    }
    return numericPrice.toLocaleString('ru-RU');
}

export const orderStatuses = [
    { id: 'paid', name: 'Оформлен' },
    { id: 'assembled', name: 'Собран' },
    { id: 'inDelivery', name: 'В доставке' },
    { id: 'completed', name: 'Завершён' },
    { id: 'pending', name: 'На оформлении' },
    { id: 'cancel_pending', name: 'Отменяется...' },
    { id: 'cancelled', name: 'Отменён' },
];

export const getOrderStatusData = (statusId: string) => {
    switch (statusId) {
        case 'paid':
            return { name: 'Оформлен', style: { backgroundColor: '#ADD8E6' } }; // светло-синий
        case 'assembled':
            return { name: 'Собран', style: { backgroundColor: '#b6b5c4ff' } }; // светло-серый с фиолетовым оттенком
        case 'inDelivery':
            return { name: 'В доставке', style: { backgroundColor: '#FFDAB9' } }; // светло-персиковый
        case 'completed':
            return { name: 'Завершён', style: { backgroundColor: '#90EE90' } }; // светло-зелёный
        case 'pending':
            return { name: 'На оформлении', style: { backgroundColor: '#FFFFE0' } }; // светло-жёлтый
        case 'cancel_pending':
            return { name: 'Отменяется...', style: { backgroundColor: '#FFFFFF' } }; // белый
        case 'cancelled':
            return { name: 'Отменён', style: { backgroundColor: '#FFC0CB' } }; // светло-розовый
        default:
            return { name: '-', style: {} };
    }
};

export const priorityOptions = Array.from({ length: 10 }, (_, i) => ({
    id: (i + 1).toString(),
    name: (i + 1).toString(),
}));

export const str = (v: string | undefined | null) => v ?? ''; // СТР → ''
export const num = (v: number | undefined | null) => v ?? 0; // NUM → 0

export function debounce<T extends (...args: any[]) => void>(fn: T, wait = 300) {
    let timer: ReturnType<typeof setTimeout> | null = null;
    return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            timer = null;
            fn.apply(this, args);
        }, wait);
    } as T;
}

// конструктор ссылки на фильтр по типу наполнителя (slug -> ?typesOfFiller=slug, fallback -> id)
export const buildFillerTypeFilterUrl = (fillerType?: Product['fillerType']): string | null => {
    try {
        if (!fillerType) return null;
        const b: any = fillerType as any;
        const slug = String(b?.url ?? '').trim();
        const fallbackId = String(b?.id ?? b?._id ?? '').trim();
        const value = slug || fallbackId;
        if (!value) return null;
        return `${PATHS.showcase}?typesOfFiller=${encodeURIComponent(value)}`;
    } catch {
        return null;
    }
};

// конструктор ссылки на фильтр по типу ткани (slug -> ?typesOfFabric=slug, fallback -> id)
export const buildFabricTypeFilterUrl = (fabricType?: Product['fabricType']): string | null => {
    try {
        if (!fabricType) return null;
        const b: any = fabricType as any;
        const slug = String(b?.url ?? '').trim();
        const fallbackId = String(b?.id ?? b?._id ?? '').trim();
        const value = slug || fallbackId;
        if (!value) return null;
        return `${PATHS.showcase}?typesOfFabric=${encodeURIComponent(value)}`;
    } catch {
        return null;
    }
};

export const parseEnvBool = (v: unknown, def: boolean): boolean => {
    if (typeof v !== 'string') return def;
    const s = v.split('#')[0].trim().toLowerCase();
    if (['1', 'true', 'yes', 'y', 'on'].includes(s)) return true;
    if (['0', 'false', 'no', 'n', 'off'].includes(s)) return false;
    return def;
};
